import { render } from "./demo.vue?vue&type=template&id=45c6d9e0"
import script from "./demo.vue?vue&type=script&lang=tsx"
export * from "./demo.vue?vue&type=script&lang=tsx"
script.render = render

export default script